<template>
	<div class="rang">
		<div class="page-title">Звание</div>
		<swiper class="rang__items"
			:modules="modules"
			:slides-per-view="isTablet ? 'auto' : 3"
			:space-between="12"
			:initial-slide="initialIndex"
			@swiper="onSwiper"
			:key="swiperKey"
		>
			<swiper-slide class="rang__slide" v-for="rang in rangs">
				<div class="rang__item"
					 :class="{
					'locked': user && user.rang && user.rang.amount < rang.amount,
					'current': user && user.rang.id === rang.id,
					}">
					<div class="rang__item-banner">
						<img class="rang__item-banner-img" :src="rang.icon_url">
					</div>
					<svg class="rang__item-icon">
						<use href="#svg-icon-checked"></use>
					</svg>
					<div class="rang__item-title">{{ rang.title }}</div>
					<div class="rang__item-rows">
						<div class="rang__item-row">
							<div class="rang__item-row-label">Сумма депозитов</div>
							<div class="rang__item-row-value lg">{{ $root.currency(rang.amount) }}</div>
						</div>
						<div class="rang__item-row">
							<div class="rang__item-row-label">Награда</div>
							<div class="rang__item-row-value">{{ $root.currency(rang.reward) }}</div>
						</div>
						<div class="rang__item-row">
							<div class="rang__item-row-label">Кешбек</div>
							<div class="rang__item-row-value">{{ rang.cashback_percent }}%</div>
						</div>
						<div class="rang__item-row">
							<div class="rang__item-row-label">Рейкбек</div>
							<div class="rang__item-row-value">{{ rang.rakeback_percent }}%</div>
						</div>
						<div class="rang__item-row">
							<div class="rang__item-row-label">Лимит на вывод в сутки</div>
							<div class="rang__item-row-value">{{ rang.withdraw_limit ? $root.currency(rang.withdraw_limit) : '∞' }}</div>
						</div>
					</div>
				</div>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
	import { Swiper, SwiperSlide } from 'swiper/vue';
	import { FreeMode , Manipulation} from 'swiper/modules';
	import { mapState } from 'pinia';
	import { useUserStore } from './../../stores/User';
	import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";
	import 'swiper/css';

	export default {
		components: {
			Swiper,
			SwiperSlide,
		},

		mixins: [
			breakpointsMixin
		],

	    data() {
	        return {
	            rangs: [],
				modules:[
					FreeMode,
					Manipulation
				],
				swiper: null
	        }
	    },
	    beforeMount() {
	        this.$root.isLoading = true;
	        this.getRangs();
	    },

		watch: {
			rangs() {
				this.scrollToActive();
			},

			swiper() {
				this.scrollToActive();
			},

			user() {
				this.scrollToActive();
			}
		},

		computed: {
			...mapState(useUserStore, ['user']),

			initialIndex() {
				return this.rangs && this.user ? this.rangs.findIndex(item => item.id === this.user.rang.id) : 0;
			},

			swiperKey() {
				return `swiper-${this.rangs?.length}${this.user?.id}${this.isTablet}`;
			}
		},

		methods: {
	        getRangs() {
	        	this.$root.axios.get('/api/info/rangs')
	        		.then(res => {
					this.rangs = res.data;

					this.$root.isLoading = false;
				});
	        },

			onSwiper(inst) {
				this.swiper = inst;
			},

			scrollToActive() {
				if (this.rangs?.length && this.swiper && this.user) {
					this.swiper.slideTo(this.rangs.findIndex(item => item.id === this.user?.rang.id) || 0);
				}
			}
	    }
	}
</script>
